import { render, staticRenderFns } from "./RegitLogo.vue?vue&type=template&id=fbf50a56&scoped=true"
import script from "./RegitLogo.vue?vue&type=script&lang=js"
export * from "./RegitLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbf50a56",
  null
  
)

export default component.exports